import { Users, Clock, AlertCircle, Calendar, UserX, CheckSquare } from 'lucide-react';

const StatCard = ({ label, value, sub, icon: Icon, accent }) => (
  <div className="p-5 rounded-xl" style={{ backgroundColor: "var(--lm-s1)", border: "1px solid var(--lm-border)" }}>
    <div className="flex items-center justify-between mb-3">
      <p className="text-xs font-medium" style={{ color: "var(--lm-ink-2)" }}>{label}</p>
      <Icon className="w-4 h-4" style={{ color: accent || "var(--lm-ink-3)" }} />
    </div>
    <p className="text-3xl font-semibold mb-2" style={{ color: "var(--lm-ink)", letterSpacing: "-1px" }}>{value}</p>
    <p className="text-xs" style={{ color: "var(--lm-ink-3)" }}>{sub}</p>
  </div>
);

const DashboardStatsCards = ({ t, stats, attendanceRate }) => (
  <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
    <StatCard
      label={t('dashboard.totalEmployees')}
      value={stats.totalEmployees}
      sub={t('dashboard.activeEmployees')}
      icon={Users}
      accent="#5e6ad2"
    />
    <div className="p-5 rounded-xl" style={{ backgroundColor: "var(--lm-s1)", border: "1px solid var(--lm-border)" }}>
      <div className="flex items-center justify-between mb-3">
        <p className="text-xs font-medium" style={{ color: "var(--lm-ink-2)" }}>{t('dashboard.todayAttendance')}</p>
        <Calendar className="w-4 h-4" style={{ color: "var(--lm-success)" }} />
      </div>
      <p className="text-3xl font-semibold mb-2" style={{ color: "var(--lm-ink)", letterSpacing: "-1px" }}>{stats.presentToday}</p>
      <div className="space-y-1.5">
        <div className="flex items-center justify-between">
          <p className="text-xs" style={{ color: "var(--lm-ink-3)" }}>{t('dashboard.attendanceRate')}</p>
          <p className="text-xs font-medium" style={{ color: "var(--lm-success)" }}>{attendanceRate}%</p>
        </div>
        <div className="h-1 rounded-full overflow-hidden" style={{ backgroundColor: "var(--lm-border)" }}>
          <div className="h-full rounded-full" style={{ width: `${attendanceRate}%`, backgroundColor: "var(--lm-success)" }} />
        </div>
      </div>
    </div>
    <StatCard
      label={t('dashboard.absentToday')}
      value={stats.absentToday ?? 0}
      sub={t('dashboard.notPresent')}
      icon={UserX}
      accent="var(--lm-error, #e5484d)"
    />
    <StatCard
      label={t('attendance.duration')}
      value={`${stats.avgWorkingHours}h`}
      sub={t('dashboard.averageToday')}
      icon={Clock}
      accent="#5e6ad2"
    />
    <StatCard
      label={t('dashboard.lateArrivals')}
      value={stats.lateArrivals}
      sub={t('dashboard.sinceYesterday')}
      icon={AlertCircle}
      accent="var(--lm-warn)"
    />
    <StatCard
      label={t('dashboard.pendingApprovals')}
      value={stats.pendingApprovals ?? 0}
      sub={t('dashboard.awaitingAction')}
      icon={CheckSquare}
      accent="var(--lm-warn)"
    />
  </div>
);

export default DashboardStatsCards;
